// ─── Admin API Endpoints ──────────────────────────────────────────
const ADMIN_BASE = '/admin';

export const ADMIN_ENDPOINTS = {
    MERCHANTS: `${ADMIN_BASE}/merchants`,
    MERCHANT_DETAIL: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}`,
    IMPERSONATE: `${ADMIN_BASE}/impersonate`,
    STOP_IMPERSONATION: `${ADMIN_BASE}/stop-impersonation`,
    AUDIT_LOG: `${ADMIN_BASE}/audit-log`,
    VERIFY_DEVICE: `${ADMIN_BASE}/verify-device`,
    USERS: `${ADMIN_BASE}/users`,
    DEVICES: `${ADMIN_BASE}/devices`,
    DEVICES_PENDING: `${ADMIN_BASE}/devices/pending`,
    MERCHANT_FEATURES: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}/features`,
    MERCHANT_STATUS: (merchantId: string) => `${ADMIN_BASE}/merchants/${merchantId}/status`,
} as const;
